import script from "./KPIPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./KPIPanel.vue?vue&type=script&setup=true&lang=js"

import "./KPIPanel.vue?vue&type=style&index=0&id=7aab14c6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7aab14c6"]])

export default __exports__